export enum LocalId {
  SLA = 1,
  LCB = 2,
}
